import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import AccordionTransition from './AccordionTransition';
import ClientProvider from './client';
export default createDemo(import.meta.url, AccordionTransition, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/accordion/demos/transition/AccordionTransition.tsx",
    "fileName": "AccordionTransition.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Accordion, { accordionClasses } from '@mui/material/Accordion';\nimport type { AccordionSlots } from '@mui/material/Accordion';\nimport AccordionSummary from '@mui/material/AccordionSummary';\nimport AccordionDetails, {\n  accordionDetailsClasses,\n} from '@mui/material/AccordionDetails';\nimport Typography from '@mui/material/Typography';\nimport ExpandMoreIcon from '@mui/icons-material/ExpandMore';\nimport Fade from '@mui/material/Fade';\n\nexport default function AccordionTransition() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const id = React.useId();\n  const [expanded, setExpanded] = React.useState(false);\n\n  const handleExpansion = () => {\n    setExpanded((prevExpanded) => !prevExpanded);\n  };\n\n  return (\n    <div>\n      <Accordion\n        expanded={expanded}\n        onChange={handleExpansion}\n        slots={{ transition: Fade as AccordionSlots['transition'] }}\n        slotProps={{ transition: { timeout: 400 } }}\n        sx={[\n          expanded\n            ? {\n                [`& .${accordionClasses.region}`]: {\n                  height: 'auto',\n                },\n                [`& .${accordionDetailsClasses.root}`]: {\n                  display: 'block',\n                },\n              }\n            : {\n                [`& .${accordionClasses.region}`]: {\n                  height: 0,\n                },\n                [`& .${accordionDetailsClasses.root}`]: {\n                  display: 'none',\n                },\n              },\n        ]}\n      >\n        <AccordionSummary\n          expandIcon={<ExpandMoreIcon />}\n          aria-controls={`${id}-panel1-content`}\n          id={`${id}-panel1-header`}\n        >\n          <Typography component=\"span\">Custom transition using Fade</Typography>\n        </AccordionSummary>\n        <AccordionDetails>\n          <Typography>\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n            malesuada lacus ex, sit amet blandit leo lobortis eget.\n          </Typography>\n        </AccordionDetails>\n      </Accordion>\n      <Accordion>\n        <AccordionSummary\n          expandIcon={<ExpandMoreIcon />}\n          aria-controls={`${id}-panel2-content`}\n          id={`${id}-panel2-header`}\n        >\n          <Typography component=\"span\">Default transition using Collapse</Typography>\n        </AccordionSummary>\n        <AccordionDetails>\n          <Typography>\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n            malesuada lacus ex, sit amet blandit leo lobortis eget.\n          </Typography>\n        </AccordionDetails>\n      </Accordion>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 78,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Accordion, { accordionClasses } from '@mui/material/Accordion';\nimport type { AccordionSlots } from '@mui/material/Accordion';\nimport AccordionSummary from '@mui/material/AccordionSummary';\nimport AccordionDetails, {\n  accordionDetailsClasses,\n} from '@mui/material/AccordionDetails';\nimport Typography from '@mui/material/Typography';\nimport ExpandMoreIcon from '@mui/icons-material/ExpandMore';\nimport Fade from '@mui/material/Fade';\n\nexport default function AccordionTransition() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const id = React.useId();\n  const [expanded, setExpanded] = React.useState(false);\n\n  const handleExpansion = () => {\n    setExpanded((prevExpanded) => !prevExpanded);\n  };\n\n  return (\n    <div>\n      <Accordion\n        expanded={expanded}\n        onChange={handleExpansion}\n        slots={{ transition: Fade as AccordionSlots['transition'] }}\n        slotProps={{ transition: { timeout: 400 } }}\n        sx={[\n          expanded\n            ? {\n                [`& .${accordionClasses.region}`]: {\n                  height: 'auto',\n                },\n                [`& .${accordionDetailsClasses.root}`]: {\n                  display: 'block',\n                },\n              }\n            : {\n                [`& .${accordionClasses.region}`]: {\n                  height: 0,\n                },\n                [`& .${accordionDetailsClasses.root}`]: {\n                  display: 'none',\n                },\n              },\n        ]}\n      >\n        <AccordionSummary\n          expandIcon={<ExpandMoreIcon />}\n          aria-controls={`${id}-panel1-content`}\n          id={`${id}-panel1-header`}\n        >\n          <Typography component=\"span\">Custom transition using Fade</Typography>\n        </AccordionSummary>\n        <AccordionDetails>\n          <Typography>\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n            malesuada lacus ex, sit amet blandit leo lobortis eget.\n          </Typography>\n        </AccordionDetails>\n      </Accordion>\n      <Accordion>\n        <AccordionSummary\n          expandIcon={<ExpandMoreIcon />}\n          aria-controls={`${id}-panel2-content`}\n          id={`${id}-panel2-header`}\n        >\n          <Typography component=\"span\">Default transition using Collapse</Typography>\n        </AccordionSummary>\n        <AccordionDetails>\n          <Typography>\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n            malesuada lacus ex, sit amet blandit leo lobortis eget.\n          </Typography>\n        </AccordionDetails>\n      </Accordion>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 78,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Accordion",
      "@mui/material/AccordionSummary",
      "@mui/material/AccordionDetails",
      "@mui/material/Typography",
      "@mui/icons-material/ExpandMore",
      "@mui/material/Fade"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
